import { SvgXml } from "../svgXml";
import { SvgXmlProps } from "../svgXml/types";
import { svgXmlList } from "./svgs";
import { SvgNameType } from "./types";


export type UiSvgsPropsType = Omit<SvgXmlProps, "xml"> & {
  name: SvgNameType;
};

export const UiSvgs = (props: UiSvgsPropsType) => {
  const { name, ...restProps } = props;
  return <SvgXml xml={svgXmlList[name]} {...restProps} />;
};
